<template>
<div>
<section class="hero">
  <div class="hero-body">
    <h1>
      {{name}} Side
    </h1>

     <img :src="pic" class="pic" />
  </div>
</section>
 
<section class="hero">
  <div class="hero-body">
    <h2>
      Did you know?
    </h2>
    <p class="subtitle">
       <span v-html="fact"></span>
    </p>
  </div>
</section>


<section class="hero" style="background-color:#dbf7d9;">
  <div class="hero-body">
    <p class="question">
       How many Adventurefuls™ can you find on the 
       <span style="font-weight:bold">{{name}}</span> side of the house?
    </p>

    <p>
      <b-numberinput v-model="value" size="is-medium" type="is-success" min="0" max="10"></b-numberinput>
    </p>
    <p>
      <div style="padding-top:6px" v-if="this.guess != this.correctAnswer && this.value != this.guess">
        <b-button  type="is-success" size="is-medium" @click='makeGuess()' > Guess</b-button> 
    </div>

      <transition name="slide-fade" mode="in-out">
          <section v-if="this.isAnswerVisible" style="padding-top:15px;" >
              <div v-if="getResponse()" class="answer-correct"><h3>Correct</h3>
                  <p>Have a look at the {{this.name}} side of the house.</p>
              </div>
              <p v-else>
                <span class="answer-wrong">Oops! Take another look and try again</span>
              </p>
          </section>
      </transition>
  </div>
</section>
  
    <section class="hero">
        <div class="hero-body ">
            <p >
              Where to next?
            </p>
          <div class="x">
          <a @click="link('')" size="is-small" style="padding-right:10px"><b-icon icon="home" /> </a>  
          <a @click="link('Left')">Left</a> - 
            <a @click="link('Front')">Front</a> -
            <a @click="link('Right')">Right</a>  
          </div>
        </div>
        <div class="foot"><a href="https://www.engineerofjoy.com" target="_blank" >engineerofjoy.com</a></div>
    </section>


  </div>
   
</template>

<script>
import { api } from "./api.js"

export default {
  name: "Side",
  props: {
    name: String,
    correctAnswer: Number,
  },
  data() {
    return {
      value: 0,
      guess: -1,
      isAnswerVisible: false
    };
  },
  computed:{
    pic(){
      if(this.name == 'Right'){
          return require("@/assets/right.jpg")
      }
      else if(this.name == 'Left'){
          return require("@/assets/left.jpg")
      }
      else if(this.name == 'Front'){
          return require("@/assets/front.jpg")
      }
      return ""
    },
    fact(){
      if(this.name == 'Right'){
          return "Juliette raised the money to build the Girl Scouts herself, even selling her rare pearl necklace for $2,800 - which would be more than $70,000 today!"
      }
      if(this.name == 'Left'){
          return "The real house was completed in 1821, so it is now officially <strong>200</strong> years old! (This gingerbread version is much fresher than that)"
      }
      if(this.name == 'Front'){
          return "Juliette hosted tea parties in the parlor of this house to convince the mothers of Savannah to let their daughters join the new club she was founding for adventureful girls!"

      }
      return ""
    }
  },
  updated(){
    
    },
  mounted(){
      //console.log("mount" + this.name)
      let data = `arg=${name}-off` 
      api.go.post('ledToggle', data)
  },
  methods:{
    link(id){
      //console.log(id);
      this.$emit('change_page',id) 
    },
    makeGuess() {
      this.$ga.event({
        eventCategory: 'Questions',
        eventAction: 'Guess',
        eventLabel: this.name,
        eventValue: this.value
      })

       //console.log("click!", api)
        this.guess = this.value
        const self = this

        this.isAnswerVisible = true
        setTimeout(() => { 
          self.isAnswerVisible = false
          self.guess = -1 
        }, 3000);

        let isCorrect = this.getResponse();
        const name = this.name.toLowerCase();
        let data = `arg=${name}-off` 

        if(isCorrect){
          this.$emit('event_child', name)
          data = `arg=${name}-on`
        }

        api.go.post('ledToggle', data)
        console.log(isCorrect, data, "lights on")

        setTimeout(function(){ 
          let data = `arg=${name}-off` 
          api.go.post('ledToggle', data)
          console.log(data + "lights off")
        }, 10000);
    },
    getResponse(){
      console.log("getResponse", this.guess)
          let response = this.guess != -1 && this.guess == this.correctAnswer
          return response
    }
  },

};
</script>
